import { useParams } from 'react-router';
import { BackButton, Box, Button, CardSpinner, ConfirmPopup, Icon, Text } from '~/commonComponents';
import Form, { FORM_FIELDS } from '../multiday/components/Form';
import { useEditJobForm } from './hooks/useEditJobForm/useEditJobForm';
import { useJob } from './hooks/useJob/useJob';

export const EditOpenJob = () => {
  const { jobId } = useParams();
  const { job, isLoading: isLoadingJob } = useJob(jobId);
  const {
    formValues,
    handleSubmit,
    setFormValues,
    isLoading: isSaving,
    confirmationExitModalOpen,
    setConfirmationExitModalOpen,
    clearPendingNavigation,
    navigateToPending,
  } = useEditJobForm(job);

  if (isLoadingJob || !formValues) {
    return <CardSpinner />;
  }

  return (
    <div className="component_container">
      <div
        className="floating_container"
        style={{ justifyContent: 'flex-start', flexDirection: 'column', paddingBottom: 120 }}
      >
        <div className="card">
          <div className="card-body" style={{ margin: 30 }}>
            <BackButton />
            <Box marginTop={20} marginBottom={60}>
              <Text bold fontSize={24} textAlign="center">
                {job?.isOnsiteInterview ? 'Edit Interview' : 'Edit Shift'}
              </Text>
            </Box>
            <Form
              job={job}
              formValues={formValues}
              setFormValues={setFormValues}
              disabledFields={[FORM_FIELDS.PROFESSIONAL, FORM_FIELDS.SKILLS] as never}
              editDate
              source="open_shift"
            />
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <Button
            text="Save Changes"
            onClick={handleSubmit}
            isLoading={isSaving}
            dataCy="save-changes-button"
          />
        </div>
      </div>

      {confirmationExitModalOpen && (
        // @ts-expect-error - ConfirmPopup is not typed
        <ConfirmPopup
          Icon={() => <Icon name="warning-outline" size={80} />}
          leftButtonAction={() => {
            clearPendingNavigation();
            setConfirmationExitModalOpen(false);
          }}
          leftButtonText="Go Back"
          rightButtonAction={navigateToPending}
          rightButtonText="Leave Anyway"
          title="Are You Sure You Want to Leave?"
          titleStyle={{ marginBottom: 20, marginTop: 20 }}
          descriptionStyle={{ marginBottom: 40 }}
          description="You've made changes to your shift request that haven't been saved. Do you still want to leave?"
        />
      )}
    </div>
  );
};
